import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ReportDTO {

  @ApiProperty()
  Id?: number;
  @ApiProperty()
  postId?:number;
  @ApiProperty()
  commentId?:number;
  @ApiProperty()
  userId:number;
  @ApiProperty()
  @IsNotEmpty({message:"Message should not be empty"})
  reportMsg:string;
  @ApiProperty()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : number;
  @ApiProperty()
  versionFlag : number;
}

export class GetReportsByPostIdDTO {  
  @ApiProperty()
  @IsNotEmpty({message:"Post id should not be empty"})
  postId:number;  
}

export class GetReportsByCmntIdDTO {
  @ApiProperty()
  @IsNotEmpty({message:"comment id should not be empty"})
  commentId:number;  
}

export class GetReportsByUserIdDTO {
  @ApiProperty()
  @IsNotEmpty({message:"User id should not be empty"})
  userId:number;  
}
